module.exports = __webpack_public_path__ + "img/404.8b06daff.png";